import styled from 'styled-components';

import { BinMIcon, EditMIcon } from 'assets/icons';
import { FullNameInputs as BaseFullNameInputs } from 'components/modules/Insurance/components/FullNameInputs/FullNameInputs';
import { GenderSelector } from 'components/modules/Insurance/components/GenderSelector/GenderSelector';
import { SubContent } from 'components/modules/Insurance/components/SubContent/SubContent';
import { Icon } from 'components/uikit/Icon/Icon';
import { Popup as PopupBase } from 'components/uikit/Popup/Popup';

const BaseText = styled.p`
  color: var(--color-black);
  margin: 0;
`;

const BaseButton = styled(Icon)`
  --color: var(--color-grey-11_60);

  cursor: pointer;
`;

export const Container = styled(SubContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 60px;
  gap: 24px;
  align-items: center;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled(BaseText)`
  font: var(--font-large-17);
`;

export const Description = styled(BaseText)`
  font: var(--font-regular-13);
  color: var(--color-grey-11_60);
`;

export const HeaderControls = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
`;

export const EditButton = styled(BaseButton).attrs({ Icon: EditMIcon })``;

export const RemoveButton = styled(BaseButton).attrs({ Icon: BinMIcon })``;

export const Genders = styled(GenderSelector)`
  gap: 8px;
  grid-column: 1 / 3;
`;

export const FullNameInputs = styled(BaseFullNameInputs)`
  grid-column: 1 / 3;
`;

export const Controls = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;

  &:not(:last-child) {
    margin-top: 8px;
  }
`;

export const Popup = styled(PopupBase)`
  max-width: 460px;
`;

export const PopupTitle = styled(BaseText)`
  font: var(--font-heading-large-24_2);

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const PopupDescription = styled(BaseText)`
  font: var(--font-regular-15);

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const PopupControls = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

export * from 'components/modules/Insurance/Insurance.styles';
